import React, { forwardRef } from 'react'
import { isEmpty } from 'lodash'
import { AmChartsBuilder, AgChartsBuilder } from '../../../Charts'
import StatusWrapper from '../../../StatusWrapper'
import UbliqueColumn from '../Column'
import UbliqueRow from '../Row'
import StripeChartMenu from '../StripeChartMenu'

import './index.scss'

const AMChart = StatusWrapper(AmChartsBuilder)
const AGChart = StatusWrapper(AgChartsBuilder)

const Charts = forwardRef(({ chartProps, chartType }, ref) => {
  return chartType === 'agchart' ? (
    <AGChart key={chartProps?.key} type={chartProps.type} config={chartProps} />
  ) : (
    <div ref={ref}>
      <AMChart {...chartProps} />
    </div>
  )
})

const StripeCharts = ({ charts }) => {
  return (
    <UbliqueRow className='ublique-row-charts'>
      {charts.map(({ config, chartType = '', chartProps, chartMenu }, idx) => (
        <>
          {!isEmpty(chartMenu) && <StripeChartMenu menuProps={chartMenu} />}
          <UbliqueColumn
            sm={config?.sm}
            md={config?.md}
            lg={config?.lg}
            key={`page-output-stripe-table-${idx}`}
          >
            <Charts
              ref={chartProps.ref}
              chartProps={chartProps}
              chartType={chartType}
            />
          </UbliqueColumn>
        </>
      ))}
    </UbliqueRow>
  )
}

export default StripeCharts
